import { Info } from "lucide-react";

/**
 * Os avisos ficam ACIMA do relatório, não no rodapé, de propósito: eles dizem
 * o quanto dá pra confiar nos números logo abaixo. Rodapé ninguém lê.
 */
export default function Avisos({ avisos }) {
  if (!avisos?.length) return null;
  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 space-y-2">
      {avisos.map((a, i) => (
        <div key={i} className="flex gap-2.5">
          <Info className="w-4 h-4 text-amber-600 dark:text-amber-500 flex-shrink-0 mt-0.5" />
          <p className="text-[13px] leading-snug text-muted-foreground">{a}</p>
        </div>
      ))}
    </div>
  );
}
